module.exports = {
    logging: {
        level: 'off'
    },
    timeout: 8000,
    maxRequestRetries: 1,
    payment: {
        view: 'modal',
        framework: 'cardinal',
        displayLoading: false
    }
};


//////////////////
// WEBPACK FOOTER
// ./config/merchantDefaultConfig.js
// module id = 26
// module chunks = 0 5 20